<template>
    <div>
        <div class="lke-titl">
            <div>
                <i class="el-icon-caret-right"></i>
                当前位置：通知
            </div>
            <div>
            </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="tab.name" :name="index + ''" v-for="(tab,index) in tabs" :key="index">
                    <div class="lke-bg">
                        <div class="lke-tab">
                            <img src="http://lnsgsjnrz.eswonline.com/learning/resbase/sites/thtylnsg/student/default/css/themes/purple/images/jxjw_ico2.gif" alt="">
                            <p><span style="color: #1EAC9F">联系电话：</span>010-65007370</p>
                        </div>
                        <div class="lke-tab">
                            <img src="http://lnsgsjnrz.eswonline.com/learning/resbase/sites/thtylnsg/student/default/css/themes/purple/images/jxjw_ico2.gif" alt="">
                            <p><span style="color: #CE7D1C">作品发送至Email：</span>30414739@qq.com</p>
                        </div>
                    </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            input: '',
            activeName: '0',
            url: '@/pages/index/assets/bird.jpeg',
            tabs: [
                {
                    name: '通知',
                    page: 1,
                    calss: [
                        {name:'课程', type: '事件'}
                    ]
                },
            ],
        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

        getClass() {},


    },
    components: {  },
};
</script>

<style>
.el-tabs__item.is-active{
    color: #2890F4;
}
.el-tabs__active-bar{
    background: #2890F4;
}
.el-tabs__item{
    font-size: 16px;
    font-weight: bold;
}
</style>

<style scoped>
.lke-titl{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    padding-bottom: 20px;
}
.lke-titl > div:first-child{
    display: flex;
    align-items: center;
}
.lke-titl i{
    color: #2890F4;
    padding-right: 5px;
    font-size: 20px;
}
.lke-bg{
    padding: 50px 0;
}
.lke-tab{
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #CCD5CC;
    width: calc(60%);
    margin: auto;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #5C5C5C;
    margin-bottom: 20px;
}
.lke-tab > img{
    padding-right: 20px;
}
.lke-tab > p > span{
    letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/StudentAction/StudentAction.vue